<template>
  <button
    id="gv-button-genio-pratiche-collegate"
    title="Genio Pratiche Collegate"
    @click="onClick"
    :class="setClass()"
  />
</template>

<script>
import mountComponent from '../../util/mountComponent';
import Vue from 'vue';

Vue.component('gv-genio-pratiche-collegate-panel', () => import('../GenioPraticheCollegate.vue'));

const name = 'gv-genio-pratiche-collegate-button';

export default {
  name: name,
  data() {
    const options = GV.config.getToolOptions(name);
    return {
      name: name,
      active: false,
      options: options,
      cssClass: 'gv-button fa fa-link',
      cssActiveClass: 'gv-button-selected',
    };
  },
  methods: {
    onClick() {
      mountComponent({
        elId: 'gv-genio-pratiche-collegate-panel',
        containerId: GV.config.containerId,
        toggleEl: true,
        vm: new Vue({
          template: `<gv-genio-pratiche-collegate-panel></gv-genio-pratiche-collegate-panel>`,
        }),
      });
    },
    setClass() {
      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
    },
  },
  mounted: function() {},
};
</script>

<style></style>



// WEBPACK FOOTER //
// GenioPraticheCollegate.vue?4ae34e00